import { LEARN_MORE } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function learnMore() {
  return callingAPIMethodWithQueue(LEARN_MORE);
}